<template>
	<button id="settings-button" type="button" @click="onClick"><IconCog /></button>
</template>

<script>
	import { mapState } from "vuex";
	import IconCog from "@/components/icons/IconCog";

	export default {
		components: {
			IconCog
		},
		computed: {
			...mapState([ "currentSong", "currentUser", "settingsMenuOpened" ])
		},
		methods: {
			onClick() {
				this.$store.commit("setMainbarExtended", false);
				if (this.currentUser === null || (this.currentUser && this.currentUser.isAnonymous)) {
					this.$modal.show("login-registration");
				} else {
					this.$store.commit("setSettingsMenuOpened", !this.settingsMenuOpened);
				}
			},
		}
	}

</script>

<style lang="scss" scoped>
	#settings-button {
		margin-right: 10px;
		padding: 6px 14px 0 14px;
		height: 40px;
		position: fixed;
		top: 0;
		top: calc(constant(safe-area-inset-top) + 0px);
		top: calc(env(safe-area-inset-top) + 0px);
		right: 0;

		.icon {
			fill: rgba(255, 255, 255, 0.85);
			width: 24px;
			margin: 0;
			padding: 0;
		}
	}
</style>
